import React from 'react';
import { UseFormMethods } from 'react-hook-form';

interface IRHFTextAreaProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    label?: string;
    name: string;
    disabled?: boolean;
    rules?: unknown;
    style?: React.CSSProperties;
    rows?: number;
    defaultValue?: string;
    isRequired?: boolean;

    onChange?: (e: React.FormEvent<HTMLTextAreaElement>) => void;
}

const RHFTextArea = (props: IRHFTextAreaProps) => {
    return (
        <div className="form-field">
            {props.label && <label htmlFor={props.name}>
                {props.label}
                {!!props.isRequired && <span style={{ color: 'red' }}>*</span>}
            </label>}
            {props.label && <br />}
            <textarea
                id="rhf-textarea"
                name={props.name}
                style={
                    !!props.disabled
                        ? { cursor: 'not-allowed', width: '100%', height: '20rem', resize: 'none' }
                        : props.style
                        ? props.style
                        : { width: '100%', height: '20rem' }
                }
                ref={props.register ? props.register(props.rules) : null}
                className={`field ${props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) ? 'error-field' : ''}`}
                rows={props.rows ? props.rows : 5}
                defaultValue={props.defaultValue ? props.defaultValue : ''}
                onChange={props?.onChange}
                disabled={props?.disabled}
            />

            <br />
            {props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) && (
                <p>{props.name.split('.')?.reduce((o, i) => o[i], props.errors)?.message}</p>
            )}
        </div>
    );
};

export default RHFTextArea;



// WEBPACK FOOTER //
// ./src/components/controls/tempRHFControls/RHFTextArea.tsx